import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=2284f722&scoped=true&"
import script from "./shop.vue?vue&type=script&lang=js&"
export * from "./shop.vue?vue&type=script&lang=js&"
import style0 from "./shop.vue?vue&type=style&index=0&id=2284f722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284f722",
  null
  
)

component.options.__file = "shop.vue"
export default component.exports